import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    documentWrapper: {
        cursor: "pointer",
    },
    deleteIcon: {
        position: "absolute",
        top: "5px",
        right: "5px",
        display: "none",
        cursor: "pointer",
        zIndex: 1,
        color: theme.palette.error.main,
        backgroundColor: "white",
        borderRadius: "4px",
    },
    documentIFrame: {
        height: "298px",
        width: "255px",
        pointerEvents: "none",
    },
    previewDocumentWrapper: {
        height: "298px",
        width: "255px",
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyItems: "center",
        justifyContent: "center",
        color: theme.palette.primary.darker,
        position: "relative",
        "&:hover $deleteIcon": {
            display: "block",
        },
    },
    previewDocumentBorder: {
        border: `solid 1px ${theme.palette.border.main}`,
    },
    noPreviewDocumentContainer: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
    noPreviewFileType: {
        fontSize: "16px",
        fontFamily: "Source Sans 3",
        fontWeight: "700",
    },
    docColor: {
        color: theme.palette.info.main,
    },
    csvColor: {
        color: theme.palette.success.main,
    },
    pdfColor: {
        color: theme.palette.error.main,
    },
    documentTitle: {
        margin: 0,
        fontSize: "12.5px",
        fontFamily: "Source Sans 3",
        color: theme.palette.primary.darker,
    },
}));
